import { render } from 'preact';
import {App} from "./component/App.js";

render(<App />, document.body);
